import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsHierarchyAnalyticsAllocationQueryParams,
  FamsHierarchyAnalyticsAllocationResponse,
  FamsHierarchyAnalyticsGovernanceQueryParams,
  FamsHierarchyAnalyticsGovernanceResponse,
  FamsHierarchyAnalyticsObjectOptionsResponse,
  FamsHierarchyAnalyticsReturnQueryParams,
  FamsHierarchyAnalyticsReturnResponse,
} from './types/hierarchy-analytics';

const request = createAppRequest();

export async function getFamsHierarchyAnalyticsObjectOptions(
  params?: Pick<
    FamsHierarchyAnalyticsAllocationQueryParams,
    'snapshotDate' | 'objectType' | 'objectKey' | 'keyword'
  >,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAnalyticsObjectOptionsResponse>(
    '/bff/fams/hierarchy-analytics/object-options',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAnalyticsAllocation(
  params?: FamsHierarchyAnalyticsAllocationQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAnalyticsAllocationResponse>(
    '/bff/fams/hierarchy-analytics/allocation',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAnalyticsReturnAttribution(
  params?: FamsHierarchyAnalyticsReturnQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAnalyticsReturnResponse>(
    '/bff/fams/hierarchy-analytics/return-attribution',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getFamsHierarchyAnalyticsGovernance(
  params?: FamsHierarchyAnalyticsGovernanceQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsHierarchyAnalyticsGovernanceResponse>(
    '/bff/fams/hierarchy-analytics/governance',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}
